import { ChangeDetectionStrategy, Component, EventEmitter, model } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ComponentHotkeyService } from '@shared/component-hotkey.service';
import { InputAutoFocusDirective } from '@shared/directives/input-auto-focus.directive';
import { ModalComponent } from '@shared/modal/modal.component';
import { FinishedComponent } from '@shared/window/window.service';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-text-input-modal',
  imports: [
    ModalComponent,
    TranslateModule,
    FormsModule,
    InputAutoFocusDirective
  ],
  templateUrl: './text-input-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ComponentHotkeyService],
})
export class TextInputModalComponent implements FinishedComponent<string> {
  public title: string = '';
  public description: string = '';

  public inputValue = model<string>();
  public finish = new EventEmitter<string>;

  constructor(
    public bsModalRef: BsModalRef) {
  }

  public submitEnter(event: KeyboardEvent): void {
    if(event.key === 'Enter') {
      this.finish.emit(this.inputValue());
    }
  }
}
